import { useQuery } from 'react-query';
import { StringParam, useQueryParam, withDefault } from 'use-query-params';
import { format, subDays } from 'date-fns';

import { Input } from '@app/components';
import { ContentLoader } from '@app/components/loaders/content-loader/ContentLoader';
import { EmailApi } from '@app/domain/email/api/EmailApi';

import { EmailDeliverabilityKpiCards } from './components/EmailDeliverabilityKpiCards';
import { EmailRecentProblemsTable } from './components/EmailRecentProblemsTable';
import { EmailDomainDeliverabilityTable } from './components/EmailDomainDeliverabilityTable';

const DATE_FORMAT = 'yyyy-MM-dd';

// admin-emailbeheer blok B (opdracht §7, Scherm 4 - Bezorgproblemen). "Laat het verschil zien
// tussen een lijstprobleem en een bezorgprobleem."
export const AdminEmailDeliverabilityPage: React.FC = () => {
  const [from, setFrom] = useQueryParam('from', withDefault(StringParam, format(subDays(new Date(), 7), DATE_FORMAT)));
  const [to, setTo] = useQueryParam('to', withDefault(StringParam, format(new Date(), DATE_FORMAT)));

  const query = useQuery(['email-deliverability', from, to], () =>
    EmailApi.adminGetEmailDeliverability(from as string, to as string)
  );

  return (
    <>
      <div className="flex flex-wrap items-end justify-end gap-4">
        <div className="flex items-end gap-3">
          <Input label="From" type="date" value={from} onChange={(e) => setFrom(e.target.value)} />
          <Input label="To" type="date" value={to} onChange={(e) => setTo(e.target.value)} />
        </div>
      </div>

      <div className="flex flex-col gap-6 pt-5">
        <ContentLoader loading={query.isLoading} error={query.error} />

        {query.data && (
          <>
            <EmailDeliverabilityKpiCards kpis={query.data.kpis} />
            <EmailDomainDeliverabilityTable rows={query.data.domains} />
            <EmailRecentProblemsTable rows={query.data.recentProblems} />
          </>
        )}
      </div>
    </>
  );
};
